module.exports = __webpack_public_path__ + "static/media/fgdj.3e7becec.png";